// NEW: UI_REVAMP
import { useEffect, useMemo, useState } from 'react';
import { FilterTriggerButton } from '../common/SearchFilterHeader';
import {
	DesktopFilterContainer,
	MobileFilterContainer,
} from '../modal/filterRecord/FilterContainers';
import DateRangeCalendarStage from './DateRangeCalendarStage';
import { CALENDAR_MIN_DATE } from './dateRangeCalendarStyles';

const SingleDatePicker = ({
	selected,
	onChange,
	maxDate,
	minDate = CALENDAR_MIN_DATE,
	isMobile = false,
	clearLabel = 'Reset',
	isTextClearButton,
	textClearButtonPadding,
}) => {
	const activeDate = useMemo(() => selected || new Date(), [selected]);
	const calendarMaxDate = maxDate || new Date();
	const [isOpen, setIsOpen] = useState(false);
	const [tempDate, setTempDate] = useState(activeDate);

	useEffect(() => {
		if (isOpen) {
			setTempDate(activeDate);
		}
	}, [isOpen, activeDate]);

	const handleConfirm = () => {
		onChange(tempDate);
		setIsOpen(false);
	};

	const handleClear = () => {
		setTempDate(calendarMaxDate);
	};

	let textClear = !isMobile;
	if (isTextClearButton !== undefined) {
		textClear = isTextClearButton;
	}

	let clearPadding;
	if (textClearButtonPadding !== undefined) {
		clearPadding = textClearButtonPadding;
	} else if (textClear) {
		clearPadding = '0 12px';
	}

	const stageComponent = (
		<DateRangeCalendarStage
			label='Draw Date'
			selectsRange={false}
			dateRange={[tempDate, null]}
			onChangeDateRange={(newRange) => setTempDate(newRange[0])}
			maxDate={calendarMaxDate}
			minDate={minDate}
			isMobile={isMobile}
			clearLabel={clearLabel}
			isTextClearButton={textClear}
			textClearButtonPadding={clearPadding}
			onClear={handleClear}
			onConfirm={handleConfirm}
		/>
	);

	if (isMobile) {
		return (
			<>
				<FilterTriggerButton onFilterClick={() => setIsOpen(!isOpen)} />
				<MobileFilterContainer isOpen={isOpen} onClose={() => setIsOpen(false)}>
					{stageComponent}
				</MobileFilterContainer>
			</>
		);
	}

	return (
		<>
			<FilterTriggerButton onFilterClick={() => setIsOpen(!isOpen)} />
			<DesktopFilterContainer
				isOpen={isOpen}
				isCalendarView={true}
				onClose={() => setIsOpen(false)}
			>
				{stageComponent}
			</DesktopFilterContainer>
		</>
	);
};

export default SingleDatePicker;
